import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { salesApi } from '../api/salesApi'
import type { PaginationParams } from '@/types/common'
import { useToast } from '@/hooks/use-toast'

export function useSales(pagination: PaginationParams) {
  return useQuery({
    queryKey: ['sales', pagination],
    queryFn: () => salesApi.getSales(pagination),
  })
}

export function useRefreshSales() {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: salesApi.refreshSales,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sales'] })
      toast({
        title: 'Success',
        description: 'Sales data refreshed from Shopify',
      })
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'Failed to refresh sales data',
        variant: 'destructive',
      })
    },
  })
}

